import daLocale from '@fullcalendar/core/locales/da';
import deLocale from '@fullcalendar/core/locales/de';
import enGbLocale from '@fullcalendar/core/locales/en-gb';
import esLocale from '@fullcalendar/core/locales/es';
import frLocale from '@fullcalendar/core/locales/fr';
import itLocale from '@fullcalendar/core/locales/it';
import nbLocale from '@fullcalendar/core/locales/nb';
import nlLocale from '@fullcalendar/core/locales/nl';
import plLocale from '@fullcalendar/core/locales/pl';
import ptLocale from '@fullcalendar/core/locales/pt';
import ptBrLocale from '@fullcalendar/core/locales/pt-br';
import svLocale from '@fullcalendar/core/locales/sv';
import { Locales } from '@griply/types';

// Shared by the day, week and month calendars — three copies drifted apart before.
export const fullCalendarLocales = [
  nlLocale,
  enGbLocale,
  esLocale,
  deLocale,
  plLocale,
  daLocale,
  svLocale,
  nbLocale,
  itLocale,
  frLocale,
  ptLocale,
  ptBrLocale,
];

export const fullCalendarLocaleMap: Record<Locales, string> = {
  [Locales.NlNL]: 'nl',
  [Locales.EnUS]: 'en-gb',
  [Locales.EsES]: 'es',
  [Locales.DeDE]: 'de',
  [Locales.PlPL]: 'pl',
  [Locales.DaDK]: 'da',
  [Locales.SvSE]: 'sv',
  [Locales.NbNO]: 'nb',
  [Locales.ItIT]: 'it',
  [Locales.FrFR]: 'fr',
  [Locales.PtPT]: 'pt',
  [Locales.PtBR]: 'pt-br',
};
